import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility.js';

const initialState = {
    appended_blurs: 0
};

const helpersBlurAppend = ( state, action ) => {
    return updateObject( state, { appended_blurs : state.appended_blurs + 1 } );
};

const helpersBlurRemove = ( state, action ) => {
    return updateObject( state, { appended_blurs : state.appended_blurs - 1 } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.HELPERS_BLUR_APPEND: return helpersBlurAppend( state, action );
    	case actionTypes.HELPERS_BLUR_REMOVE: return helpersBlurRemove( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/helpers/blur.js